import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceDto } from '../../../models/invoice.dto';
import { isEmptyArray, notBlank } from '../../../utils/base';
import {
  useApproveInvoicesMutation,
  useDownloadInvoiceMutation, useDownloadInvoiceReceiptMutation,
  useDownloadInvoicesMutation,
} from '../../../store/invoices/invoices.api';
import { Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';

interface PropsType {
  selectedInvoices: InvoiceDto[];
  resetSelectedInvoices: () => void;
  onClose: () => void;
  setShownInvoices: React.Dispatch<React.SetStateAction<InvoiceDto[]>>;
}

const BottomActionBar = ({ selectedInvoices, resetSelectedInvoices, onClose, setShownInvoices }: PropsType) => {
  const [approveInvoices] = useApproveInvoicesMutation();
  const [downloadInvoices] = useDownloadInvoicesMutation();
  const [downloadInvoice] = useDownloadInvoiceMutation();
  const [downloadInvoiceReceipt] = useDownloadInvoiceReceiptMutation();
  const [translate] = useTranslation(['common']);

  const getInvoiceIds = () => selectedInvoices.map((invoice) => invoice.invoiceId);

  const handleResetSelectedInvoicesAndClose = () => {
    resetSelectedInvoices();
    onClose();
  };

  const approveSelectedInvoices = async () => {
    const ids = selectedInvoices.map(i => i.invoiceId);
    const updated = await approveInvoices(ids).unwrap();
    if (updated) {
      const map = new Map(updated.map(i => [i.invoiceId, i]));
      setShownInvoices((prev: InvoiceDto[]) => prev.map(i => map.get(i.invoiceId) ?? i));
    }

    handleResetSelectedInvoicesAndClose();
  };

  const downloadSelectedInvoices = () => {
    const oneFileToDownload = selectedInvoices && selectedInvoices.length === 1;

    oneFileToDownload
      ?  (notBlank(selectedInvoices[0]?.receiptPath)
          ? downloadInvoiceReceipt({ invoiceId: selectedInvoices[0].invoiceId }).then(() => handleResetSelectedInvoicesAndClose())
          : downloadInvoice({ invoiceId: selectedInvoices[0].invoiceId }).then(() => handleResetSelectedInvoicesAndClose()))
      : downloadInvoices(getInvoiceIds()).then(() => handleResetSelectedInvoicesAndClose());
  };


  useEffect(() => {
    if (isEmptyArray(selectedInvoices)) {
      onClose()
    }
  }, [selectedInvoices]);


  return (
    <div className="bottom-action-bar">
      <div className="action-content">
          <div className="action-left">
            <div className="selected"><span>{selectedInvoices.length}</span> <p>{translate('common:common.selected')}</p>
            </div>
            <Button className="btn outline-primary" onClick={approveSelectedInvoices}>
              {translate('common:common.approveAll')}
            </Button>
            <Button className="btn outline-primary" onClick={downloadSelectedInvoices}>
              {translate('common:common.downloadAll')}
            </Button>
          </div>
          <div onClick={onClose}>
            <X size={24} className='icon' />
        </div>
      </div>
    </div>
  );
};

export default BottomActionBar;
